import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { UploadTenementMasterListModel } from "src/app/model/UploadTenementMasterListModel";
import { ViewApplicationSearchModel } from "src/app/model/ViewApplicationSearchModel";
import { MasterService } from "src/app/services/master.service";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { TenementModalComponent } from "../../tenement-exchange/tenement-modal/tenement-modal";
import { MatDialog } from "@angular/material/dialog";
import { ModalController } from "@ionic/angular";
import { TenementEditModalComponent } from "../edit-modal/edit-modal.component";

@Component({
  selector: "app-secure-view-application",
  templateUrl: "./upload-tenement-list.component.html",
  styleUrls: ["./upload-tenement-list.component.scss"],
})
export class UploadTenementMasterList implements OnInit {
  page: Page<UploadTenementMasterListModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  isLoading: boolean = false;

  viewApplicationSearchModel: ViewApplicationSearchModel;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<UploadTenementMasterListModel> =
    new MatTableDataSource();

  displayedColumns: string[] = [
    "id",
    "projectCode",
    "mahareraNo",
    // "location",
    "incomeGrp",
    "propertyType",
    "ctsNo",
    "tenement",
    // "builtupArea",
    // "carpetArea",
    // "cost",
    // "blocked",
    // "remark",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private viewApplicationService: ViewApplicationService,
    private _snackBar: MatSnackBar,
    private masterService: MasterService,
    public dialog: MatDialog,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-view-application-filterText"),
        [Validators.required, Validators.minLength(3)]
      ),
    });
    this.filterForm.controls["filterText"].setValue(null);

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.onLoad();
    this.page = null;
    this.dataSource = new MatTableDataSource();
    this.currentPage = 0;
    this.paginator.pageIndex = this.currentPage;
    this.paginator.length = 0;
  }

  onLoad() {
    this.isLoading = true;
    this.masterService
      .fetchtenementMasterList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page) => {
          this.page = page;
          this.dataSource = new MatTableDataSource(page.content);
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
          this.isLoading = false;
        },
        (error) => {
          this.errorToast(
            // error?.error?.message ||
            //   error?.errorMessage ||
            //   error?.error?.errorMessage
            "No data found for this Board"
          );
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }

  async openModal(key: number) {
    const modal = await this.modalCtrl.create({
      component: TenementEditModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        key: key,
      },
    });
    await modal.present();
    // this.isSubmitDisabled = false;
    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      this.saveEditDetails(data);
    }
  }

  deleteMasterEntry(key: number) {
    this.isLoading = true;

    if (confirm("Do you want to Delete the Record ?")) {
      this.masterService.deleteMasterEntry(key, "N").subscribe((data: any) => {
        if (data.status === "SUCCESS") {
          this.masterService.successToast("Deleted Successfully");
          // let selectedObj = this.page.content.find((o) => o.key === key);
          // selectedObj.activeFlag = "N";
          this.onLoad();
        } else {
          this.isLoading = false;

          this.errorToast(data.errorMessage);
        }
      });
    }
    this.isLoading = false;
  }

  saveEditDetails(data) {
    this.isLoading = true;
    let payload: any = {
      key: data.key,
      // mahareraNo: data.mahareraNo,
      // location: data.location,
      propertyType: data.propertyType,
      incomeGrpType: data.incomeGrpType,
      // ctsNo: data.ctsNo,
      buildingNo: data.buildingNo,
      flatNo: data.flatNo,
      builtupArea: data.builtupArea,
      carpetArea: data.carpetArea,
      cost: data.cost,
      maintenanceCost: data.maintainCost,
      blocked: data.blocked,
      remarks: data.remarks,
      wing: data.wing,
      floor: data.floor,
    };
    this.masterService.updateMasterDetails(payload).subscribe(
      (data: any) => {
        if (data.status === "SUCCESS") {
          this.masterService.successToast("Saved Successfully");
          this.onLoad();
          this.isLoading = false;
        } else {
          //  this.isSubmitDisabled = false;
          this.isLoading = false;

          this.masterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        console.log(error);
        this.masterService.errorToast(error.error.errorMessage, 5 * 1000);
      }
    );
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.page = null;
      this.dataSource = null;
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;

      localStorage.setItem(
        "app-secure-view-application-filterText",
        this.filterForm.value.filterText
      );
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 3 char) for Search",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }

  showStatusClass(status: string) {
    let statusClass = "text-white p-1 pl-2 pr-2 text-sm border-round";
    if (status === "Verified" || status === "Answered") {
      return statusClass + " bg-green-400";
    } else if (status === "Not Applicable") {
      return statusClass + " surface-700";
    } else if (status?.indexOf("Pending") >= 0) {
      return statusClass + " bg-orange-400";
    } else {
      return statusClass + " bg-orange-400";
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    if (this.filterForm.value.filterText) {
      this.onSearch();
    }
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
}
